<template>
  <div class="userset-msg">
    <h1 class="title">
      <i class="icon icon-youjian" style="font-size: 18px"></i>
      <span>{{ $t('base_userset_msg.zhan_nei') }}</span>
    </h1>
    <div style="padding: 0 60px">
      <el-form ref="sms" :model="site" label-width="80px">
        <div v-for="(item, index) in propertyMap.bas_msg_class" :key="index">
          <el-form-item :label="item.name">
            <el-switch v-model="site[item.value]" :disabled="site[item.value] == undefined" @change="switchMsg('site', item.value, site[item.value])"></el-switch>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <h1 class="title">
      <i class="icon icon-youjian" style="font-size: 18px"></i>
      <span>{{ $t('base_userset_msg.you_jian') }}</span>
    </h1>
    <div style="padding: 0 60px">
      <el-form ref="email" :model="email" label-width="80px">
        <div v-for="(item, index) in propertyMap.bas_msg_class" :key="index">
          <el-form-item :label="item.name">
            <el-switch v-model="email[item.value]" :disabled="email[item.value] == undefined" @change="switchMsg('email', item.value, email[item.value])"></el-switch>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <h1 class="title">
      <i class="icon icon-youjian" style="font-size: 18px"></i>
      <span>{{ $t('base_userset_msg.duan_xin') }}</span>
    </h1>
    <div style="padding: 0 60px">
      <el-form ref="sms" :model="sms" label-width="80px">
        <div v-for="(item, index) in propertyMap.bas_msg_class" :key="index">
          <el-form-item :label="item.name">
            <el-switch v-model="sms[item.value]" :disabled="sms[item.value] == undefined" @change="switchMsg('sms', item.value, sms[item.value])"></el-switch>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  data() {
    return {
      appId: '',
      code: '',
      isBindWechat: null,
      site: {},
      email: {},
      sms: {}
    };
  },
  mounted() {
    this.getMsgList();
    this.getDictionary('bas_msg_class');
  },
  methods: {
    // 获取登录配置
    getMsgList: function () {
      this.$getJSON(apis.MsgSetList).then((res) => {
        this.site = res.data.site;
        this.email = res.data.email;
        this.sms = res.data.sms;
      });
    },
    // 解除绑定
    switchMsg: function (pushChannel, msgClass, msgReceive) {
      this.$postJSON(
        apis.MsgSetup,
        {
          msgClass: msgClass,
          pushChannel: pushChannel,
          msgReceive: msgReceive
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getMsgList();
      });
    }
  }
};
</script>

<style lang="scss">
.userset-msg {
  padding: 32px;
  .title {
    font-size: 18px;
    font-weight: bold;
    height: 20px;
    font-size: 14px;
    color: #495057;
    line-height: 20px;
    margin-bottom: 20px;
    .icon {
      color: #0d9ae0;
      float: left;
      margin-right: 4px;
    }
  }
}
</style>
